export class Driver {
    id: string;
    name: string;
    identifier: string;
    active: boolean = true;
    fleets: any[] = [];
}
